import axios from "axios";
import { Base_URL } from "../../url";
import { toast } from "react-toastify";


export const saveNewLead = async (data, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/RawLeads/CreateRawLead?UserName=${userName}`,
      data);
    console.log(response, 'sdjrfghsfdfd')
    return response;
  } catch (error) {
    throw error.response?.data || "Failed to save Data";
  }
};

export const fetchRawLeads = async () => {
  try {
    const response = await axios.get(`${Base_URL}/RawLeads/GetAllRawLeads`);
    // console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error At Fetching Data!";
  }
};


export const postLeadExcel = async (beffiles, id) => {
  console.log(beffiles, id);
  if (!beffiles) {
    alert("Please select a file first");
    return;
  }
  const formData = new FormData();
  formData.append("file", beffiles);
  try {
    const response = await axios.post(`${Base_URL}/RawLeads/uploadData?id=${id}`, formData);
    return response;
  }
  catch (error) {
    console.error("Error", error);
  }
}

export const postedRawLeads = async (leadId, userName) => {
  const RawLeadId = {
    RawLeadId : leadId
  }
  console.log(RawLeadId, 'rawLeadId')
  // return
  try {
    const response = await axios.patch(`${Base_URL}/RawLeads/PostRawLead?UserName=${userName}`, RawLeadId);
    console.log(response, 'sdgdhgd gjrgrgrrjgj');
    return response;
  } catch (error) {
    throw error.response?.data || "Error At Fetching Data!";
  }
};

export const getRawLeadDataById = async (requestId) => {
  const url = `${Base_URL}/RawLeads/${requestId}`;
  try {
    const response = await axios.get(url);
    console.log(response.data, 'response on body type')
    // return
    return response.data;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}  // 
